import { powerSupplySteps } from "../../constants";
import PowerSupplyGroupDTO from "./PowerSupplyGroupDTO";
import _DTO from "./_DTO";


export default class PowerSupplyManagementDTO extends _DTO {

  constructor(powerSupplyManagement) {
    super();
    this.step = PowerSupplyManagementDTO.getOrDefault(powerSupplyManagement, 'step', powerSupplySteps.requirements);
    this.powerSupplyGroups = PowerSupplyManagementDTO.getMappedOrDefault(powerSupplyManagement, 'powerSupplyGroups', [], data => (data || []).map(d => new PowerSupplyGroupDTO(d || {})));
    this.isEdited =  PowerSupplyManagementDTO.getOrDefault(powerSupplyManagement, 'isEdited', false);
    this.requirements = PowerSupplyManagementDTO.getOrDefault(powerSupplyManagement, 'requirements', {});
  }
}
